import React from "react";
import { CheckIcon, XIcon } from "lucide-react";
import { afterItems, beforeItems } from "../../data/content";
import { SectionHeading } from "../ui/SectionHeading";
import { TransformCta } from "../ui/TransformCta";
export function BeforeAfter() {
  return <section className="bg-cream px-5 py-16 sm:py-24" aria-labelledby="ba-title" data-id="element-71" data-mp="26k04imtveq2k">
      <div id="ba-title" data-id="element-72" data-mp="22mly12xkqwe9">
        <SectionHeading title={<>
              From scattered information… <em className="italic text-brand-600" data-id="element-74" data-mp="2z8nuuwth85mz">to a clear system</em>
            </>} subtitle="A system you can reference whenever you need it." data-id="element-73" data-mp="2zb1nkz0op5rd" />
      </div>

      <div className="mx-auto mt-10 grid max-w-5xl grid-cols-1 gap-5 md:grid-cols-2" data-id="element-75" data-mp="2qcg8jduf88vc">
        <article className="flex flex-col rounded-3xl bg-white p-6 ring-1 ring-rose-200 sm:p-8" data-id="element-76" data-mp="2lazb5sb5b4ji">
          <div className="flex items-center gap-3" data-id="element-77" data-mp="1ewhuswoasyns">
            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-rose-500 text-white" data-id="element-78" data-mp="19vke6oixscoe">
              <XIcon className="h-6 w-6" strokeWidth={3} aria-hidden="true" data-id="element-79" data-mp="1754744hc8w4p" />
            </span>
            <h3 className="text-xl font-black uppercase tracking-wide text-rose-600" data-id="element-80" data-mp="1c4pbiufa1wot">Before Reflexology 360°</h3>
          </div>
          <ul className="mt-6 space-y-4" data-id="element-81" data-mp="y462bjz2skl2">
            {beforeItems.map(item => <li key={item} className="flex gap-3 text-[17px] leading-snug text-ink/80" data-id="element-82" data-mp="132g082c6pzad">
                <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-rose-500" strokeWidth={3} aria-hidden="true" data-id="element-83" data-mp="odtlo2udtbk7" />
                <span data-id="element-84" data-mp="t6cxovdf7ymw">{item}</span>
              </li>)}
          </ul>
        </article>

        <article className="flex flex-col rounded-3xl bg-brand-800 p-6 text-white shadow-xl shadow-brand-900/20 sm:p-8" data-id="element-85" data-mp="ffhkx7zswxe1">
          <div className="flex items-center gap-3" data-id="element-86" data-mp="jg1igcoae30p">
            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-cta text-white" data-id="element-87" data-mp="5fqqf6b8qidy">
              <CheckIcon className="h-6 w-6" strokeWidth={3} aria-hidden="true" data-id="element-88" data-mp="afd75pqa2gri" />
            </span>
            <h3 className="text-xl font-black uppercase tracking-wide text-white" data-id="element-89" data-mp="2c4j34igj3mst">With Reflexology 360°</h3>
          </div>
          <ul className="mt-6 space-y-4" data-id="element-90" data-mp="27bznlfya6hld">
            {afterItems.map(item => <li key={item} className="flex gap-3 text-[17px] leading-snug text-brand-50" data-id="element-91" data-mp="23d0hhs0tcesc">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand-300" strokeWidth={3} aria-hidden="true" data-id="element-92" data-mp="1ydxfkgg4qool" />
                <span data-id="element-93" data-mp="2v1tvdj3qtfyr">{item}</span>
              </li>)}
          </ul>
          <p className="mt-auto pt-6 text-[17px] leading-snug text-brand-100" data-id="element-94" data-mp="2r2l5ipbtq28h">
            Instead of asking yourself <em className="font-semibold text-white" data-id="element-95" data-mp="2m1dtge2negw0">“What do I do next?”</em> — you have a
            system to guide your next step.
          </p>
        </article>
      </div>

      <TransformCta label="I want to practice with a clear system" data-id="element-96" data-mp="1antd4ceoguz6" />
    </section>;
}